/**
 * Resource: //quirksmode.org/js/cookies.html
 */

import Logger from "./Logger";

export default class Cookie {
  static isCookieAvailable = (): boolean => {
    try {
      const date = new Date().getTime() + 24 * 60 * 60 * 1000;
      document.cookie = "cookie_set=cookie_value; expires=" + date;
      const cookies = document.cookie.split(";");
      for (let index = 0; index < cookies.length; index++) {
        const cookie = cookies[index];
        if (cookie.indexOf("cookie_set") !== -1) {
          document.cookie =
            "cookie_set=cookie_value; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          return true;
        }
      }
      return false;
    } catch (err) {
      Logger.error("Cookies: ", err);
      return false;
    }
  };

  static get = (name: string): string | null => {
    if (window.document) {
      const nameEQ = name + "=";
      const ca = window.document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
      }
    }
    return null;
  };
}
